// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__cc7rA","label":"CategoryService_label__B0OuJ","location":"CategoryService_location__2Ovzz"};